import { ComponentType, ReactElement } from 'react'

interface ConditionalRenderProps<TProps extends object> {
  predicate: boolean | (() => boolean)
  Component?: ComponentType<TProps>
  element?: ReactElement<unknown>
  props?: TProps
}

export function ConditionalRender<TProps extends object>({
  predicate,
  Component,
  props,
  element
}: ConditionalRenderProps<TProps>) {
  const doRender = typeof predicate === 'function' ? predicate() : predicate

  if (!doRender) {
    return null
  }

  if (element) {
    return element
  }

  if (Component) {
    return <Component {...(props as TProps)} />
  }

  return null
}
